import script from "./ObjectiveGame.vue?vue&type=script&setup=true&lang=js"
export * from "./ObjectiveGame.vue?vue&type=script&setup=true&lang=js"

import "./ObjectiveGame.vue?vue&type=style&index=0&id=2d36dd2c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d36dd2c"]])

export default __exports__